import { render, staticRenderFns } from "./PrepararProcesso.vue?vue&type=template&id=4b6794b4&scoped=true&"
import script from "./PrepararProcesso.vue?vue&type=script&lang=js&"
export * from "./PrepararProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6794b4",
  null
  
)

export default component.exports